import axios from '../util/axiosConfig';


export const fetchBodyPartsRequestAPI = async () => {
    return await axios.get(`/api/v1/master/body-parts`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}